module.exports = __webpack_public_path__ + "img/album14_19.b71d9e68.jpg";